"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildTREFromConfig;
var _transientRenderEngine = _interopRequireDefault(require("@native-html/transient-render-engine"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Build a {@link TRenderEngine} instance from a configuration object.
 *
 * @remarks This utility can be useful to test and debug the TRE layer of your
 * application.
 *
 * @param props - The configuration from which a TRE should be built.
 */
function buildTREFromConfig(props) {
  var allowedStyles = props.allowedStyles,
    _props$ignoredStyles = props.ignoredStyles,
    ignoredStyles = _props$ignoredStyles === void 0 ? [] : _props$ignoredStyles,
    ignoredDomTags = props.ignoredDomTags,
    ignoreDomNode = props.ignoreDomNode,
    domVisitors = props.domVisitors,
    htmlParserOptions = props.htmlParserOptions,
    baseStyle = props.baseStyle,
    classesStyles = props.classesStyles,
    tagsStyles = props.tagsStyles,
    idsStyles = props.idsStyles,
    enableCSSInlineProcessing = props.enableCSSInlineProcessing,
    enableUserAgentStyles = props.enableUserAgentStyles,
    _props$systemFonts = props.systemFonts,
    systemFonts = _props$systemFonts === void 0 ? [] : _props$systemFonts,
    _props$fallbackFonts = props.fallbackFonts,
    fallbackFonts = _props$fallbackFonts === void 0 ? {} : _props$fallbackFonts,
    _props$customHTMLElem = props.customHTMLElementModels,
    customHTMLElementModels = _props$customHTMLElem === void 0 ? {} : _props$customHTMLElem,
    emSize = props.emSize,
    setMarkersForTNode = props.setMarkersForTNode,
    selectDomRoot = props.selectDomRoot,
    dangerouslyDisableHoisting = props.dangerouslyDisableHoisting,
    dangerouslyDisableWhitespaceCollapsing = props.dangerouslyDisableWhitespaceCollapsing;
  var customizeHTMLModels = Object.keys(customHTMLElementModels).length ? function (defaultModels) {
    return _objectSpread(_objectSpread({}, defaultModels), customHTMLElementModels);
  } : undefined;
  var fontMap = {};
  systemFonts.forEach(function (font) {
    fontMap[font] = true;
  });
  var isFontSupported = function isFontSupported(fontFamily) {
    if (fallbackFonts[fontFamily]) {
      return fallbackFonts[fontFamily];
    }
    /* istanbul ignore next */

    return fontMap[fontFamily] || false;
  };
  return new _transientRenderEngine.default({
    customizeHTMLModels: customizeHTMLModels,
    cssProcessorConfig: {
      isFontSupported: isFontSupported,
      inlinePropertiesBlacklist: ignoredStyles,
      inlinePropertiesWhitelist: allowedStyles,
      rootFontSize: emSize
    },
    htmlParserOptions: _objectSpread({
      decodeEntities: true
    }, htmlParserOptions),
    stylesConfig: {
      baseStyle: baseStyle,
      enableCSSInlineProcessing: enableCSSInlineProcessing,
      enableUserAgentStyles: enableUserAgentStyles,
      classesStyles: classesStyles,
      idsStyles: idsStyles,
      tagsStyles: tagsStyles
    },
    ignoredDomTags: ignoredDomTags,
    ignoreDomNode: ignoreDomNode,
    domVisitors: domVisitors,
    setMarkersForTNode: setMarkersForTNode,
    selectDomRoot: selectDomRoot,
    dangerouslyDisableHoisting: dangerouslyDisableHoisting,
    dangerouslyDisableWhitespaceCollapsing: dangerouslyDisableWhitespaceCollapsing
  });
}